import { Box } from '@mui/material';
import React from 'react';
import { TMaterialStyleItem, TMaterialStyles } from '../../theme';
import { ContentWrapperWithClose } from './ContentWrapperWithClose';
import { TIllustration } from '../Illustration';
import { AttemptsLabel } from '../Labels/AttemptsLabel';

interface IModalWrapper extends React.PropsWithChildren {
  onClose?: () => void;
  contentWrappperSx?: TMaterialStyleItem;
  backgroundIllustrationName?: TIllustration;
  hasLabel?: boolean;
  attempts?: number;
  isDark?: boolean;
}

export const ModalWrapper: React.FC<IModalWrapper> = ({
  children,
  onClose,
  contentWrappperSx,
  backgroundIllustrationName,
  hasLabel,
  attempts,
  isDark,
}) => {
  return (
    <Box sx={materialStyles.container}>
      <ContentWrapperWithClose
        wrapperContainerSx={contentWrappperSx}
        onClose={onClose}
        illustrationName={backgroundIllustrationName}
        isDark={isDark}
      >
        {children}
      </ContentWrapperWithClose>
      {hasLabel && <AttemptsLabel attempts={attempts} />}
    </Box>
  );
};

const materialStyles: TMaterialStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    alignItems: 'center',
    p: 4,
    borderRadius: '14px',
  },
};
